import { useCallback, useEffect } from "react"
import {
	BIChartData,
	BIChartLegendVisibility,
	BIFilters,
	BIFormData,
	BIIsLoadingChart,
	BIIsLoadingTable, BISelectedOfficeOptions,
	BISelectedOffice,
	BITableData,
	clearBISignals, BIIs3DTable, BIHeaders, BISubHeaders, BI3DTableData, BIGroupingHeader, BIGoalMissing, BIAsked, BIOptionLabels, BIActiveGoal,
} from 'Pages/BusinessLogistics/BI/Page/@signals'
import { BISchema } from 'Pages/BusinessLogistics/BI/Page/schema'
import { canSubmit } from 'Pages/BusinessLogistics/BI/Page/@services/submit'
import { askedFrom, mergeLabels } from 'Pages/BusinessLogistics/BI/Page/@services/snapshot'
import { submitBody } from 'Pages/BusinessLogistics/BI/Page/@services/goals'
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { isLoadingCommonFilters } from "@signals"
import { batch } from "@preact/signals-react"

export default function useSubmitBIFilters() {

	const { showToast } = useToast()

	useEffect(() => {
		if (isLoadingCommonFilters.value) onSubmit()
	}, [isLoadingCommonFilters.value])


	const onSubmit = useCallback(() => {
		// every path searches through here (Search, run=1, Filter by specific office, Try again): never an incomplete
		// form, e.g. an emptied pick-up (CU-869fmk5ge D8 c)
		if (!canSubmit(BIFormData.value, BISchema, BIGoalMissing.value)) {
			batch(() => {
				isLoadingCommonFilters.value = false
				BIIsLoadingTable.value = false
				BIIsLoadingChart.value = false
			})
			showToast.warning('Fill the missing fields of the form first')
			return
		}
		clearBISignals()
		const form = BIFormData.value
		const asked = askedFrom({ form, labels: BIOptionLabels.value, selectedOffice: BISelectedOffice.value })
		batch(() => {
			BIIsLoadingTable.value = true
			BIIsLoadingChart.value = true
			// the copy the sentence reads while searching and after: never the form being edited (CA 11)
			BIAsked.value = asked
		})
		// the question it came from travels next to the form, never inside it (CU-869fmk5ge CA 17)
		postSubmit(`${BACKEND_APIS.DASHBOARD}/results`, submitBody(form, BIActiveGoal.value?.goal?.id))
			.then(res => {
				BIIs3DTable.value = res.is3Dimesions
				BISelectedOfficeOptions.value = res?.officeSelector?.length ? res?.officeSelector : []
				BIFilters.value = res.filters
				if(!res.is3Dimesions) {
					BITableData.value = {
						trows: {
							avg: res.tableDataAvg,
							min: res.tableDataMin,
							max: res.tableDataMax,
						},
						columnValues: res.xlist,
						rowValues: res.rowValues,
						noResults: res.no_results
					}
					BIChartData.value = {
						chartData: {
							avg: res.chartDataAvg,
							min: res.chartDataMin,
							max: res.chartDataMax,
						},
						keySeries: res.keySeries,
						xlist: res.xlist
					}
					BIChartLegendVisibility.value = res.keySeries.map(({ dataKey }) => dataKey)
				} else {
					BIHeaders.value = res.headers
					BISubHeaders.value = res.subHeaders
					BI3DTableData.value = {
						avg: res.results.avg_price,
						min: res.results.min_price,
						max: res.results.max_price
					}
					BIGroupingHeader.value = res.columnName
				}

				showToast.success('Search finished')
				batch(() => {
					// the office selector names the offices searched (for "at Málaga Airport (1 of 12 offices)")
					BIOptionLabels.value = mergeLabels(BIOptionLabels.value, 'office', res?.officeSelector)
					if (BIAsked.value === asked) BIAsked.value = { ...asked, labels: mergeLabels(asked.labels, 'office', res?.officeSelector), phase: 'done' }
					BIIsLoadingTable.value = false
					isLoadingCommonFilters.value = false
					BIIsLoadingChart.value = false
				})
			})
			.catch(() => {
				showToast.error('Something went wrong!')
				batch(() => {
					// the question stays on screen, with Try again (UX D3)
					if (BIAsked.value === asked) BIAsked.value = { ...asked, phase: 'failed' }
					BIIsLoadingTable.value = false
					isLoadingCommonFilters.value = false
					BIIsLoadingChart.value = false
				})
			})
	}, [JSON.stringify(BIFormData.value), BISelectedOffice.value])

}